const events = {
    accordionOpen: 'accordion-item.open',
};

export default events;